export default "__VITE_ASSET__Bm5CQiQ3__"